export const FinancierDocumentTypes = [
  'Edital',
  'Cotação',
  'Questionamento',
  'Impugnação',
  'Termo aditivo',
  'Outros Anexos'
];
